import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './core/layout/layout.component';

export const routes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('./features/auth/auth.routes').then((m) => m.authRoutes),
    },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [authGuard],
        children: [
            {
                path: 'dashboard',
                loadChildren: () => import('./features/dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
            },

            // --- Module Administration ---
            {
                path: 'administration',
                data: { breadcrumb: 'Administration' },
                loadChildren: () => import('./features/administration/administration.routes').then((m) => m.administrationRoutes),
            },

            // --- Module Gouvernance ---
            {
                path: 'gouvernance',
                data: { breadcrumb: 'Gouvernance' },
                loadChildren: () => import('./features/gouvernance/gouvernance.routes').then((m) => m.gouvernanceRoutes),
            },

            // --- Module Performance (LOT2 — Suivi Performance) ---
            {
                path: 'suivi-performance',
                data: { breadcrumb: 'Suivi Performance' },
                loadChildren: () => import('./features/performance/performance.routes').then((m) => m.performanceRoutes),
            },

            // --- Module Parametres metier (Tables de reference) ---
            {
                path: 'parametres-metier',
                data: { breadcrumb: 'Paramétrage' },
                loadChildren: () => import('./features/parametrage/parametrage.routes').then((m) => m.parametrageRoutes),
            },

            // --- Profile (raccourci direct) ---
            // Route personnelle : accessible a tout utilisateur authentifie.
            // Pas de rbacGuard : un utilisateur doit toujours pouvoir consulter son propre profil.
            // Protection assuree par l'authGuard herite du parent.
            {
                path: 'profile',
                loadComponent: () => import('./features/administration/users/profile/profile').then((m) => m.ProfileComponent),
                data: { breadcrumb: 'Mon Profil' },
            },

            // --- Showcase (design system) ---
            {
                path: 'showcase',
                loadComponent: () => import('./features/showcase/showcase').then((m) => m.ShowcaseComponent),
                data: { breadcrumb: 'Showcase' },
            },

            // --- Redirections de compatibilite (anciens chemins) ---
            { path: 'referentiels', redirectTo: 'parametres-metier', pathMatch: 'prefix' },
            { path: 'utilisateurs', redirectTo: 'administration/utilisateurs', pathMatch: 'full' },
            { path: 'rbac/roles', redirectTo: 'administration/rbac/roles', pathMatch: 'full' },
            {
                path: 'rbac/permissions',
                redirectTo: 'administration/rbac/permissions',
                pathMatch: 'full',
            },
            { path: 'rbac/analytics', redirectTo: 'administration/rbac/analytics', pathMatch: 'full' },
            { path: 'audits', redirectTo: 'administration/audits', pathMatch: 'full' },
            {
                path: 'configuration/sessions',
                redirectTo: 'administration/configuration/sessions',
                pathMatch: 'full',
            },

            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: 'erreur/403',
        loadComponent: () => import('./features/errors/forbidden/forbidden').then((m) => m.ForbiddenComponent),
    },
    {
        path: 'erreur/500',
        loadComponent: () => import('./features/errors/server-error/server-error').then((m) => m.ServerErrorComponent),
    },
    {
        path: '**',
        loadComponent: () => import('./features/errors/not-found/not-found').then((m) => m.NotFoundComponent),
    },
];
